import { render, staticRenderFns } from "./ForecastHandsonTable.vue?vue&type=template&id=0f67da6c&scoped=true&"
import script from "./ForecastHandsonTable.vue?vue&type=script&lang=js&"
export * from "./ForecastHandsonTable.vue?vue&type=script&lang=js&"
import style0 from "./ForecastHandsonTable.vue?vue&type=style&index=0&id=0f67da6c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67da6c",
  null
  
)

export default component.exports